var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3359,
    cy: 15,
    r: 15,
    fill: "#F0F1ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6272 9.87236C20.9496 10.1947 20.9496 10.7174 20.6272 11.0398L16.4515 15.2155L20.6272 19.3911C20.9495 19.7135 20.9495 20.2362 20.6272 20.5585C20.3048 20.8809 19.7821 20.8809 19.4598 20.5585L15.2841 16.3829L11.1084 20.5585C10.7861 20.8809 10.2634 20.8809 9.94101 20.5585C9.61864 20.2362 9.61864 19.7135 9.94101 19.3911L14.1167 15.2155L9.941 11.0398C9.61863 10.7174 9.61863 10.1947 9.941 9.87238C10.2634 9.55001 10.7861 9.55001 11.1084 9.87238L15.2841 14.048L19.4598 9.87236C19.7821 9.54999 20.3048 9.54999 20.6272 9.87236Z",
    fill: "#FF4550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.6e3013b312db0ba69f076bb1b1ca4295.svg";
export { ForwardRef as ReactComponent };